import { createElement, Component, Fragment, Children, cloneElement } from 'react';
import { Grid, Typography, Button, Stepper, Step, StepLabel, Table as Table$1, TableBody as TableBody$1, TableCell as TableCell$1, TableHead as TableHead$1, TableRow as TableRow$1, MenuItem, IconButton, Card, CardContent } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import { Formik, Field, FieldArray } from 'formik';
import { TextField } from 'formik-material-ui';
import DeleteIcon from '@material-ui/icons/Delete';
import Add from '@material-ui/icons/AddCircle';

/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var styles = function (theme) { return ({
    root: {
        width: '100%'
    },
    heading: {
        fontSize: theme.typography.pxToRem(15),
        flexBasis: '33.33%',
        flexShrink: 0
    },
    previewItemHeading: {
        fontSize: theme.typography.pxToRem(15),
        flexBasis: '33.33%',
        flexShrink: 0,
        textAlign: 'right',
        fontWeight: 500
    },
    previewItem: {
        textAlign: 'left'
    },
    secondaryHeading: {
        fontSize: theme.typography.pxToRem(15),
        color: theme.palette.text.secondary
    },
    topMarginButton: {
        marginTop: theme.spacing.unit * 3,
        marginRight: theme.spacing.unit * 1
    },
    tableRoot: {
        width: '100%',
        marginTop: theme.spacing.unit * 3,
        overflowX: 'auto'
    },
    table: {
        minWidth: 700
    }
}); };
var Preview = /** @class */ (function (_super) {
    __extends(Preview, _super);
    function Preview() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            expanded: null
        };
        _this.handleChange = function (panel) { return function (_event, expanded) {
            _this.setState({
                expanded: expanded ? panel : false
            });
        }; };
        return _this;
    }
    Preview.prototype.render = function () {
        var _this = this;
        var _a = this.props, classes = _a.classes, formSchema = _a.formSchema, values = _a.values;
        var expanded = this.state.expanded;
        return (createElement(Grid, { container: true, spacing: 8, direction: "column" },
            createElement(Grid, { item: true, xs: 12 },
                createElement("div", { className: classes.root }, formSchema.forms.map(function (form, index) { return (createElement(ExpansionPanel, { key: index, expanded: expanded === index, onChange: _this.handleChange(index) },
                    createElement(ExpansionPanelSummary, { expandIcon: createElement(ExpandMoreIcon, null) },
                        createElement(Typography, { className: classes.heading }, form.title),
                        createElement(Typography, { className: classes.secondaryHeading }, form.description)),
                    createElement(ExpansionPanelDetails, null,
                        createElement(Grid, { container: true, spacing: 8 }, form.properties.map(function (property, index) {
                            if (property.component === 'text' || property.component === 'select') {
                                return (createElement(Fragment, { key: index },
                                    createElement(Grid, { item: true, xs: 3 },
                                        createElement(Typography, { className: classes.previewItemHeading },
                                            property.label,
                                            ":")),
                                    createElement(Grid, { item: true, xs: 9, className: classes.previewItem },
                                        createElement(Typography, null, values[property.name]))));
                            }
                            else if (property.component === 'table') {
                                return (createElement(Paper, { className: classes.tableRoot, key: index },
                                    createElement(Table, { className: classes.table },
                                        createElement(TableHead, null,
                                            createElement(TableRow, null, property.rows.map(function (col, index) { return (createElement(TableCell, { key: index }, col.label)); }))),
                                        createElement(TableBody, null, values[property.name] &&
                                            values[property.name].map(function (cell, i) { return (createElement(TableRow, { key: i }, property.rows.map(function (col, index) { return (createElement(TableCell, { key: index }, cell[col.name])); }))); })))));
                            }
                            else {
                                return null;
                            }
                        }))))); })))));
    };
    return Preview;
}(Component));
var Preview$1 = withStyles(styles)(Preview);

var Wizard = /** @class */ (function (_super) {
    __extends(Wizard, _super);
    function Wizard(props) {
        var _this = _super.call(this, props) || this;
        _this.next = function (values) {
            if (_this.props.children) {
                _this.setState(function (state) { return ({
                    page: Math.min(state.page + 1, _this.props.children.length),
                    values: values
                }); });
            }
        };
        _this.previous = function () {
            return _this.setState(function (state) { return ({
                page: Math.max(state.page - 1, 0)
            }); });
        };
        _this.validate = function (values) {
            var activePage = Children.toArray(_this.props.children)[_this.state.page];
            return activePage.props.validate ? activePage.props.validate(values) : {};
        };
        _this.handleSubmit = function (values, bag) {
            var _a = _this.props, children = _a.children, onSubmit = _a.onSubmit;
            var page = _this.state.page;
            var isLastPage = page === Children.count(children);
            if (isLastPage) {
                return onSubmit(values, bag);
            }
            else {
                bag.setTouched({});
                bag.setSubmitting(false);
                _this.next(values);
            }
        };
        _this.state = {
            page: 0,
            initValues: props.initialValues
        };
        return _this;
    }
    Wizard.prototype.render = function () {
        var _this = this;
        var _a = this.props, children = _a.children, steps = _a.steps, formSchema = _a.formSchema;
        var _b = this.state, page = _b.page, initValues = _b.initValues;
        var activePage = Children.toArray(children)[page];
        var isLastPage = page === Children.count(children);
        return (createElement(Fragment, null,
            createElement(Stepper, { activeStep: page, alternativeLabel: true }, steps.map(function (label, index) { return (createElement(Step, { key: index },
                createElement(StepLabel, null, label))); })),
            createElement(Formik, { initialValues: initValues, enableReinitialize: false, validate: this.validate, onSubmit: this.handleSubmit, render: function (_a) {
                    var values = _a.values, handleSubmit = _a.handleSubmit, isSubmitting = _a.isSubmitting;
                    return (createElement("form", { onSubmit: handleSubmit },
                        activePage && cloneElement(activePage, { values: values }),
                        isLastPage && createElement(Preview$1, { values: values, formSchema: formSchema }),
                        createElement("div", { className: "buttons" },
                            page > 0 && (createElement(Button, { variant: "contained", color: "primary", onClick: _this.previous }, "Previous")),
                            !isLastPage && (createElement(Button, { variant: "contained", color: "primary", type: "submit" }, "Next")),
                            isLastPage && (createElement(Button, { variant: "contained", color: "primary", type: "submit", disabled: isSubmitting }, "Submit")))));
                } })));
    };
    Wizard.Page = function (_a) {
        var children = _a.children;
        return children;
    };
    return Wizard;
}(Component));

var styles$1 = function (theme) { return ({
    table: {
        marginBottom: theme.spacing.unit * 2,
        minWidth: 340
    },
    tableWrapper: {
        maxWidth: '100%',
        overflowX: 'auto'
    },
    textAlignCenter: {
        textAlign: 'center',
        paddingTop: 10
    },
    tableHeadSmall: {
        textAlign: 'center',
        padding: 0,
        width: '5%'
    },
    tableTextField: {
        marginLeft: theme.spacing.unit * 0,
        marginRight: theme.spacing.unit * 0,
        padding: 0,
        marginTop: theme.spacing.unit * 0
    },
    tableTextField2: {
        // width: '8rem',
        marginLeft: theme.spacing.unit * 0,
        marginRight: theme.spacing.unit * 0,
        padding: 0,
        marginTop: theme.spacing.unit * 0
    },
    tableTextField3: {
        width: '4rem',
        marginLeft: theme.spacing.unit * 0,
        marginRight: theme.spacing.unit * 0,
        padding: 0,
        marginTop: theme.spacing.unit * 0
    },
    title: {
        flex: '0 0 auto'
    },
    heading: {
        marginTop: theme.spacing.unit * 3,
        fontSize: '18px'
    },
    heading2: {
        marginTop: theme.spacing.unit * 2,
        marginLeft: theme.spacing.unit * 2,
        fontSize: '16px'
    },
    header: {
        color: theme.palette.common.white,
        backgroundColor: theme.palette.primary.main,
        padding: 15,
        marginBottom: 0,
        textAlign: 'left'
    },
    topMargin: {
        marginTop: theme.spacing.unit * 3
    },
    resize: {
        fontSize: 12
    },
    addText: {
        margin: theme.spacing.unit * 3,
        cursor: 'pointer'
    },
    icon: {
        fontSize: 30,
        marginBottom: -10,
        paddingRight: 5,
        paddingLeft: 5,
        cursor: 'pointer'
    }
}); };
var CustomTableCell = withStyles({
    head: {
        fontSize: 13,
        padding: '0.8rem',
        textAlign: 'center'
    },
    body: {
        fontSize: 12,
        padding: '0.5rem',
        textAlign: 'center',
        verticalAlign: 'top'
    }
})(TableCell$1);
// prev { fields, meta: { error, submitFailed }, classes, rows, title }
function FormTable(_a) {
    var arrayHelpers = _a.arrayHelpers, classes = _a.classes, rows = _a.rows, title = _a.title, name = _a.name, values = _a.values;
    return (createElement(Card, { style: { flex: 1 } },
        createElement(Typography, { className: classes.header, variant: "h6", gutterBottom: true }, title),
        createElement(CardContent, null,
            createElement("div", { className: classes.tableWrapper },
                createElement(Table$1, { className: classes.table },
                    createElement(TableHead$1, null,
                        createElement(TableRow$1, null,
                            rows.map(function (row) { return (createElement(CustomTableCell, { className: classes.textAlignCenter, key: row.label }, row.label)); }),
                            createElement(CustomTableCell, { className: classes.textAlignCenter }, "Action"))),
                    createElement(TableBody$1, null, values[name] &&
                        values[name].map(function (request, parentIndex) { return (createElement(TableRow$1, { key: parentIndex + "-" + request },
                            rows.map(function (row, index) {
                                if (row.component === 'text') {
                                    return (createElement(CustomTableCell, { key: index },
                                        createElement(Field, { name: name + "." + parentIndex + "." + row.name, component: TextField, className: classes.tableTextField, type: "text", margin: "dense", variant: "outlined", InputProps: {
                                                classes: {
                                                    input: classes.resize
                                                },
                                                inputProps: {
                                                    maxLength: 50
                                                }
                                            } })));
                                }
                                if (row.component === 'select') {
                                    return (createElement(CustomTableCell, { key: index },
                                        createElement(Field, { name: name + "." + parentIndex + "." + row.name, component: TextField, className: classes.tableTextField2, margin: "dense", variant: "outlined", select: true, InputProps: {
                                                classes: {
                                                    input: classes.resize
                                                }
                                            } }, row.elements.map(function (option) { return (createElement(MenuItem, { key: option.value, value: option.value }, option.label)); }))));
                                }
                                else
                                    return null;
                            }),
                            createElement(CustomTableCell, null,
                                createElement(IconButton, { "aria-label": "Delete", id: name + "." + parentIndex + "-deleteBtn", onClick: function () { return arrayHelpers.remove(parentIndex); } },
                                    createElement(DeleteIcon, null))))); })))),
            createElement(Grid, { container: true },
                createElement(Grid, null,
                    createElement(Typography, { className: classes.addText, variant: "body2", id: arrayHelpers.name + "-addBtn", color: "primary", onClick: function () { return arrayHelpers.push(); } },
                        createElement(Add, { className: classes.icon }),
                        " Add Row"))))));
}
var FormTable$1 = withStyles(styles$1)(FormTable);

var styles$2 = function (theme) { return ({
    container: {
        display: 'flex',
        flexWrap: 'wrap'
    },
    textField: {
        marginTop: theme.spacing.unit * 2,
        marginRight: theme.spacing.unit * 4,
        width: '100%'
    },
    longTextField: {
        marginLeft: theme.spacing.unit * 4,
        marginRight: theme.spacing.unit * 4
    },
    menu: {
        width: 400
    },
    table: {
        minWidth: 300,
        marginBottom: theme.spacing.unit * 2
    },
    textAlignCenter: {
        textAlign: 'center',
        margin: 'auto'
    },
    topMargin: {
        marginBottom: theme.spacing.unit * 3
    },
    topMarginButton: {
        marginTop: theme.spacing.unit * 3,
        marginRight: theme.spacing.unit * 1
    },
    header: {
        color: theme.palette.common.white,
        backgroundColor: theme.palette.primary.main,
        padding: 15
    },
    headerContacts: {
        marginTop: theme.spacing.unit * 5,
        color: theme.palette.common.white,
        backgroundColor: theme.palette.primary.main,
        padding: 15,
        marginBottom: 0
    }
}); };
var MaterialForm = /** @class */ (function (_super) {
    __extends(MaterialForm, _super);
    function MaterialForm() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MaterialForm.prototype.render = function () {
        var _a = this.props, classes = _a.classes, schema = _a.schema, values = _a.values;
        var ParentComp; // parent component can be any other react component
        if (typeof schema.isCard === 'boolean' && !schema.isCard) {
            ParentComp = Fragment;
        }
        else {
            ParentComp = Card;
        }
        return (createElement(Wizard.Page, null,
            createElement(ParentComp, null,
                schema.title ? (createElement(Typography, { className: classes.header, variant: "h6", gutterBottom: true }, schema.title)) : null,
                createElement(CardContent, null,
                    createElement(Grid, { container: true, spacing: 8, style: { flex: 1 }, justify: "center" }, schema.properties.map(function (item, index) {
                        if (item.component === 'text') {
                            return (createElement(Grid, { item: true, xs: 4, key: index },
                                createElement(Field, { name: item.name, component: TextField, label: item.label, className: classes.textField, margin: "normal", variant: "outlined" })));
                        }
                        if (item.component === 'select') {
                            return (createElement(Grid, { item: true, xs: 4, key: index },
                                createElement(Field, { name: item.name, component: TextField, label: item.label, className: classes.textField, margin: "normal", variant: "outlined", select: true }, item.elements.map(function (option) { return (createElement(MenuItem, { key: option.value, value: option.value }, option.label)); }))));
                        }
                        if (item.component === 'table') {
                            return (createElement(Grid, { item: true, xs: 10, key: index },
                                createElement(FieldArray, { name: item.name, render: function (arrayHelpers) { return (createElement(FormTable$1, { arrayHelpers: arrayHelpers, title: item.title, rows: item.rows, name: item.name, values: values })); } })));
                        }
                        return null;
                    }))))));
    };
    return MaterialForm;
}(Component));
var MaterialForm$1 = withStyles(styles$2)(MaterialForm);

var styles$3 = {
    container: {
        display: 'flex',
        flexWrap: 'wrap'
    },
    root: {
        flexGrow: 1,
        textAlign: 'center' // TODO
    },
    marginBottomButton: {
        marginTop: 15
    }
};
var Form = /** @class */ (function (_super) {
    __extends(Form, _super);
    function Form() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Form.prototype.getSteps = function () {
        var nameList = this.props.schema.forms.map(function (form) { return form.title; });
        nameList.push('Preview');
        return nameList;
    };
    Form.prototype.render = function () {
        var steps = this.getSteps();
        var _a = this.props, classes = _a.classes, schema = _a.schema, initialValues = _a.initialValues, onSubmit = _a.onSubmit;
        return (createElement("div", { className: classes.root },
            createElement(Grid, { container: true, spacing: 8 },
                createElement(Grid, { item: true, xs: 12 },
                    createElement(Wizard, { formSchema: schema, steps: steps, initialValues: initialValues, onSubmit: function (values, actions) {
                            onSubmit(values, actions);
                            actions.setSubmitting(false);
                        } }, this.props.schema.forms.map(function (form, index) {
                        return createElement(MaterialForm$1, { schema: form, key: index });
                    }))))));
    };
    return Form;
}(Component));
var Form$1 = withStyles(styles$3)(Form);

export default Form$1;
//# sourceMappingURL=index.es.js.map



//////////////////
// WEBPACK FOOTER
// ../dist/index.es.js
// module id = 437
// module chunks = 0